import React, { useState } from "react"
import {
  Collapse,
  Navbar,
  NavbarToggler,
  // NavbarBrand,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import Logo from "../images/Logo_White.png"
import "../style/header.css"

function Header({ siteTitle }) {
  const [isOpen, setIsOpen] = useState(false)

  function toggle() {
    setIsOpen(!isOpen)
  }

  return (
    <header>
      <Navbar className="navbar-dark bg-primary topLevelNav" expand="lg">
        {/* <NavbarBrand componentClass="span"> */}
        <Link className="navbar-brand logo" to="/">
          <img src={Logo} className="header-logo" alt="Logo" />
        </Link>
        {/* </NavbarBrand> */}
        <div className="header-title-container">
          <Link className="navbar-brand" to="/">
            {/* International Software Products */}
            <h1 className="navbar-brand-h1">INTERNATIONAL SOFTWARE PRODUCTS</h1>
          </Link>
        </div>
        <NavbarToggler onClick={toggle} />
        {/* <div className="hamburger-menu"> */}
        <Collapse isOpen={isOpen} navbar>
          {/* <Nav className="header-nav .mr-xs-2" navbar> */}
          <Nav className="header-nav" navbar>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Products & Services
              </DropdownToggle>
              <DropdownMenu
                className="drop-down-menu"
                right
                style={{ float: "right", width: "215px" }}
              >
                <Link
                  className="nav-link"
                  to="/products"
                  style={{ padding: 0 }}
                >
                  <DropdownItem>Products Home</DropdownItem>
                </Link>
                <DropdownItem divider />
                <Link
                  className="nav-link"
                  to="/replication"
                  style={{ padding: 0 }}
                >
                  <DropdownItem>Replication</DropdownItem>
                </Link>
                <Link
                  className="nav-link"
                  to="/mirroring"
                  style={{ padding: 0 }}
                >
                  <DropdownItem>Mirroring</DropdownItem>
                </Link>
                <Link
                  className="nav-link"
                  to="/monitoring"
                  style={{ padding: 0 }}
                >
                  <DropdownItem>Performance Monitoring</DropdownItem>
                </Link>
                <Link
                  className="nav-link"
                  to="/analysis"
                  style={{ padding: 0 }}
                >
                  <DropdownItem>Data Analysis</DropdownItem>
                </Link>
                <Link
                  className="nav-link"
                  to="/auditing"
                  style={{ padding: 0 }}
                >
                  <DropdownItem>Auditing</DropdownItem>
                </Link>
                <Link className="nav-link" to="/dbcopy" style={{ padding: 0 }}>
                  <DropdownItem>Database Copy</DropdownItem>
                </Link>
                <Link
                  className="nav-link"
                  to="/dataextracts"
                  style={{ padding: 0 }}
                >
                  <DropdownItem>Simple Data Extracts (SDE)</DropdownItem>
                </Link>
                <DropdownItem divider />
                <Link
                  className="nav-link"
                  to="/consulting"
                  style={{ padding: 0 }}
                >
                  <DropdownItem>Consulting</DropdownItem>
                </Link>
                <DropdownItem divider />
                <Link
                  className="nav-link"
                  to="/specialprojects"
                  style={{ padding: 0 }}
                >
                  <DropdownItem>Special Projects</DropdownItem>
                </Link>
              </DropdownMenu>
            </UncontrolledDropdown>
            <NavItem>
              <Link className="nav-link" to="/support">
                Contact & Support
              </Link>
            </NavItem>
            <NavItem>
              <Link className="nav-link" to="/offices">
                Offices
              </Link>
            </NavItem>
            <NavItem>
              <Link className="nav-link" to="/partners">
                Partners
              </Link>
            </NavItem>
          </Nav>
        </Collapse>
        {/* </div> */}
      </Navbar>
    </header>
  )
}

// <header>
//   <nav
//     className="navbar navbar-expand-md navbar-dark bg-primary"
//     // style={topLevelNav}
//   >
//     <Link className="navbar-brand" to="/">
//       <img
//         src={Logo}
//         className="img-fluid"
//         style={{ height: "60px", maxWidth: "100%" }}
//         alt="Logo"
//       />
//     </Link>
//     <Link className="navbar-brand" to="/">
//       {siteTitle}
//     </Link>
//     <button
//       className="navbar-toggler"
//       type="button"
//       data-toggle="collapse"
//       data-target="#headerNav"
//       aria-controls="headerNav"
//       aria-expanded="false"
//       aria-label="Toggle navigation"
//     >
//       <span className="navbar-toggler-icon"></span>
//     </button>

//     <div className="collapse navbar-collapse" id="headerNav">
//       <ul className="navbar-nav ml-auto">
//         <li className="nav-item">
//           <Link className="nav-link" to="/products">
//             Products Services
//           </Link>
//         </li>
//         <li className="nav-item">
//           <Link className="nav-link" to="/support">
//             Support
//           </Link>
//         </li>
//         <li className="nav-item">
//           <Link className="nav-link" to="/offices">
//             Offices
//           </Link>
//         </li>
//         <li className="nav-item">
//           <Link className="nav-link" to="/partners">
//             Partners
//           </Link>
//         </li>
//         <li className="nav-item">
//           <Link className="nav-link" to="/contact">
//             Contact
//           </Link>
//         </li>
//       </ul>
//       {/* <form className="form-inline my-2 my-lg-0">
//       <input className="form-control mr-sm-2" type="text" placeholder="Search">
//       <button className="btn btn-secondary my-2 my-sm-0" type="submit">Search</button>
//     </form> */}
//     </div>
//   </nav>
// </header>

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
